import React from 'react';
import { Plus, Pencil } from 'lucide-react';
import './CardEditRow.css';

// CardEditRow -- the builder-mode affordance for one card row, shared by the
// anonymous /providers profile-card builder and the /employers/create listing-
// card builder. When `onEdit` is absent (every viewer surface: recruiter deck,
// provider deck, share page, admin previews) it renders children untouched, so
// existing cards are pixel-identical. With onEdit:
//   - a filled row keeps its content and gains a full-row hit area + pencil;
//   - an empty row swaps to an "Add ..." prompt instead of a bare dash.
// Taps stopPropagation because FlipCard flips on any card click -- editing a
// row must never also flip the card. Keydown is stopped too: FlipCard's
// wrapper flips on Enter/Space at the keydown stage, BEFORE the button's own
// synthesized click, so a keyboard activation would otherwise do both.
export default function CardEditRow({ onEdit, label, empty, prompt, Icon, className = '', children }) {
  if (!onEdit) return children;

  const handle = (e) => {
    e.stopPropagation();
    onEdit();
  };
  const stopKeys = (e) => e.stopPropagation();

  if (empty) {
    return (
      <button
        type="button"
        className={`crna-cardedit crna-cardedit--empty ${className}`.trim()}
        onClick={handle}
        onKeyDown={stopKeys}
      >
        {Icon ? <Icon size={20} className="icon-inline" aria-hidden="true" /> : null}
        <span className="crna-cardedit-prompt">
          <Plus size={14} aria-hidden="true" />
          {prompt}
        </span>
      </button>
    );
  }

  return (
    <div className={`crna-cardedit ${className}`.trim()}>
      {children}
      <button
        type="button"
        className="crna-cardedit-hit"
        aria-label={`Edit ${label}`}
        onClick={handle}
        onKeyDown={stopKeys}
      >
        <Pencil size={14} aria-hidden="true" />
      </button>
    </div>
  );
}
